import React, { useContext, useState } from "react";
import { size } from "lodash";
import * as S from "./styles";
import iconUser from "../../assets/user/account-circle.svg";
import Button from "../Button";
import { mask } from "../../utils/mask";
import api from "../../services/api";
import agente from "../../services/agents";
import { toast } from "react-toastify";
import { IoClose } from "react-icons/io5";
import { Field, Form, Formik } from "formik";
import InputText from "../InputText";
import desmaskIfNumber from "../../utils/desmaskIfNumber";
import { Context } from "../../context/globalContext";

export default function TransferPoPup({
  setOpenPopup,
  itemsSelected,
  updateList,
  page,
  endPoint,
  messageSuccess,
  messageFailed,
}) {
  const [initialState, setInitialState] = useState({
    id: null,
    cpfCnpj: "",
    nome: "",
    totalStores: 0,
    transferringStores: 0,
    failedStores: 0,
  });

  const { setIsLoading, isLoading } = useContext(Context);

  async function onBlurCnpj(cnpj) {
    try {
      const response = await agente.searchAgents(cnpj);
      if (
        response?.data &&
        (response.status === 201 || response.status === 200)
      ) {
        const content = response?.data?.content;
        setInitialState({
          ...initialState,
          cpfCnpj: content?.[0]?.pessoa?.cpfCnpj,
          id: content?.[0]?.id,
          nome: content?.[0]?.nomeAgente,
        });
      } else if (!response) {
        setInitialState({
          ...initialState,
          id: null,
          nome: "",
        });
        toast.error(
          "Erro ao buscar os dados deste cnpj, tente novamente mais tarde!"
        );
      }
    } catch (err) {
      setInitialState({
        ...initialState,
        id: null,
        nome: "",
      });
      if (err?.response?.data?.message) {
        toast.error(err?.response?.data?.message);
      } else {
        toast.error(
          "Erro ao buscar os dados deste cnpj, tente novamente mais tarde!"
        );
      }
    }
  }
  const handleStoreTransfer = async () => {
    setIsLoading(true);

    const url = endPoint + "/transferencia/" + initialState?.id;
    const totalStores = size(itemsSelected);
    let transferringStores = 0;
    let failedStores = 0;

    for (let i = 0; i < totalStores; i++) {
      transferringStores++;
      setInitialState({
        ...initialState,
        totalStores,
        transferringStores,
        failedStores,
      });
      try {
        await api.post(url, [itemsSelected[i].id]);
      } catch (e) {
        failedStores++;
        console.error(e);
      }
    }
    setIsLoading(false);
    if (failedStores == 0) {
      toast.success(`Lojas transferidas com sucesso!`);
      setOpenPopup(false);
    }
    if (failedStores !== totalStores) {
      updateList();
    }
  };

  const onClose = () => {
    setOpenPopup(false);
  };

  return (
    <>
      <S.PopupBackground>
        <S.PopupContainer>
          <S.TitleCloseBtn>
            <button onClick={onClose}>
              <IoClose />
            </button>
          </S.TitleCloseBtn>
          <S.UserTitle>
            <img src={iconUser} alt="" />
          </S.UserTitle>

          <S.BodyTitle>
            <Formik
              initialValues={initialState}
              enableReinitialize={true}
              onSubmit={(values) => handleStoreTransfer}
            >
              {({ errors, touched, values, setFieldValue }) => (
                <Form>
                  <Field
                    name="cpfCnpj"
                    id="cpfCnpj"
                    render={({ field }) => (
                      <InputText
                        {...field}
                        disabled={isLoading}
                        type="text"
                        width="100%"
                        label="CPF/CNPJ*:"
                        maskChar=""
                        currentType="cpf/cnpj"
                        currency="false"
                        error={errors.cpfCnpj && touched.cpfCnpj}
                        onBlur={(e) => {
                          onBlurCnpj(desmaskIfNumber(e.target.value));
                          setFieldValue("cpfCnpj", e.target.value);
                        }}
                      />
                    )}
                  />
                </Form>
              )}
            </Formik>
          </S.BodyTitle>

          <S.BodyUser>
            <label>
              CPF/CNPJ:{" "}
              {mask(
                initialState.cpfCnpj,
                initialState?.cpfCnpj > 11
                  ? "##.###.###/####-##"
                  : "###.###.###-##",
                true
              )}
              <br />
              Nome: {initialState.nome}
            </label>
          </S.BodyUser>

          <S.FooterUser>
            <Button disabled={!initialState.id} onClick={handleStoreTransfer}>
              Sim! Transferir
            </Button>
          </S.FooterUser>

          <S.FooterUser>
            {isLoading && (
              <S.MessageWrapper>
                Transferindo lojas: {initialState.transferringStores} /{" "}
                {initialState.totalStores}
              </S.MessageWrapper>
            )}
            {initialState.failedStores > 0 && (
              <S.MessageWrapper>
                Lojas com falha: {initialState.failedStores}
              </S.MessageWrapper>
            )}
          </S.FooterUser>
        </S.PopupContainer>
      </S.PopupBackground>
    </>
  );
}
